<template>
  <share-button :entity-type="entityType" :entity-slug="entitySlug" :channel-settings="channelSettings"
                :utm-medium="utmMedium" :share-url-from-url="shareUrlFromUrl" icon-class="icon-x-twitter" />
</template>

<script>
import ButtonMixin from './button-mixin'

export default {
  mixins: [ButtonMixin],

  methods: {
    shareUrlFromUrl(url) {
      let params = new URLSearchParams({ url })

      // Use just the first part of the locale, e.g. 'de' instead of 'de-CH'
      params.append('lang', this.i18n.locale().split('-')[0])

      if (this.channelSettings.orgHandle) {
        params.append('via', this.channelSettings.orgHandle)
      }

      return `https://twitter.com/intent/tweet?${params.toString()}`
    }
  }
}
</script>
